import { parseAccountsForFeature } from '@/assets/scripts/parsers/accounts'

/** Returns Accounts Balances
@return { Array }
*/
export const getAccountsBalances = state => parseAccountsForFeature(state.accountsBalances)

/** returns Schedule Types
 @return { Array }
 */
 export const getScheduleTypes = state => state.scheduleTypes

/** Returns Transfers Categories List
@return { Array }
*/
export const getTransfersCategoriesList = state => state.transfersCategoriesList

/** Returns Transfers Motives List
@return { Array }
*/
export const getTransfersMotivesList = state => state.transfersMotivesList

/** returns Transfers Operations List
@returns { Array }
*/
export const getTransfersOperationsList = state => state.transfersOperationsList

 /** returns transfers list
@return { Array }
*/
export const getTransfersList = state => state.transfersList

/** returns Smart Transfers List
@return { Array }
*/
export const getSmartTransfersList = state => {
    return state.smartTransfersList
}

/** returns favorites list
@return { Array }
*/
export const getFavoritesList = state => state.favoritesList

/** returns favorites has more
@return { Boolean }
*/
export const getFavoritesHasMore = state => state.favoritesHasMore

/** returns beneficiaries list
@return { Array }
*/
export const getBeneficiariesList = state => state.beneficiariesList
